import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=4e3f60d2&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {IconHamburger: require('/lasso/components/icons/IconHamburger.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e3f60d2')) {
      api.createRecord('4e3f60d2', component.options)
    } else {
      api.reload('4e3f60d2', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=4e3f60d2&", function () {
      api.rerender('4e3f60d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/PageHeader.vue"
export default component.exports